<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">
        <!--
          {{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }}  {{ this.$t('Footer.Sol') }}
           -->  
        </div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">{{ this.$t('Footer.Sag') }}</div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>
 